/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-syntax */
import qs from 'qs';
import validate from '../vendor/validate';
import { Dialog } from './modal';

class ValidateForm {
	constructor(formID, onSubmit = () => {}) {
		this.formID = formID;
		this.formEl = document.querySelector(`#${formID}`);
		this.submitButton = this.formEl.querySelector('[type="submit"]');
		this.onSubmit = onSubmit;

		this.formEl.setAttribute('novalidate', 'true');
		this.initValidate();
		this.addListeners();
	}

	addListeners() {
		this.formEl.addEventListener('submit', this.handleFormSubmit.bind(this), true);
	}

	initValidate() {
		const inputEls = this.formEl.querySelectorAll('input[required]:not([type="radio"]):not([type="checkbox"])');
		for (const inputEl of inputEls) {
			inputEl.addEventListener('blur', validate.inputHandler);
			inputEl.addEventListener('input', validate.inputHandler);
			inputEl.addEventListener('change', validate.inputHandler);
		}

		const selectEls = this.formEl.querySelectorAll('select[required]');
		for (const selectEl of selectEls) {
			selectEl.addEventListener('change', validate.inputHandler);
		}

		const dropdowns = this.formEl.querySelectorAll('.dropdown[required]');
		for (const dropdownsEl of dropdowns) {
			if (dropdownsEl.querySelectorAll('.checkbox').length) {
				const checkboxesNode = dropdownsEl.querySelectorAll('.checkbox');
				checkboxesNode.forEach((elem) => {
					elem.addEventListener('change', validate.inputHandler);
				});
			} else {
				const dropdownListItemNode = dropdownsEl.querySelectorAll('.dropdown-item');
				dropdownListItemNode.forEach((elem) => {
					elem.addEventListener('click', validate.inputHandler);
				});
			}
		}

		const checkboxEls = this.formEl.querySelectorAll('input[required][type="checkbox"]');
		for (const checkboxEl of checkboxEls) {
			checkboxEl.addEventListener('change', validate.inputHandler);
		}

		const radioEls = this.formEl.querySelectorAll('input[required][type="radio"]');
		for (const radioEl of radioEls) {
			radioEl.addEventListener('change', validate.inputHandler);
		}
	}

	reInitRadioValidate(groupEl) {
		const radioEls = groupEl.querySelectorAll('input[required][type="radio"]');
		for (const radioEl of radioEls) {
			radioEl.addEventListener('change', validate.inputHandler);
		}
	}

	removeErrorMsg(elem) {
		if (elem.classList.contains('error')) {
			elem.classList.remove('error');
			const errorEl = elem.querySelector('.error-message');
			elem.removeChild(errorEl);
		}
	}

	addValidate(sectionEl) {
		const inputEls = sectionEl.querySelectorAll('input[aria-required="false"]:not([type="radio"]):not([type="checkbox"])');
		for (const inputEl of inputEls) {
			inputEl.required = true;
			inputEl.setAttribute('aria-required', 'true');

			inputEl.addEventListener('blur', validate.inputHandler);
			inputEl.addEventListener('input', validate.inputHandler);
			inputEl.addEventListener('change', validate.inputHandler);
		}

		const selectEls = sectionEl.querySelectorAll('select[aria-required="false"]');
		for (const selectEl of selectEls) {
			selectEl.required = true;
			selectEl.setAttribute('aria-required', 'true');

			selectEl.addEventListener('change', validate.inputHandler);
		}

		const dropdowns = sectionEl.querySelectorAll('.dropdown[aria-required="false"]');
		for (const dropdownsEl of dropdowns) {
			dropdownsEl.setAttribute('required', '');
			dropdownsEl.setAttribute('aria-required', 'false');

			if (dropdownsEl.querySelectorAll('.checkbox').length) {
				const checkboxesNode = dropdownsEl.querySelectorAll('.checkbox');
				checkboxesNode.forEach((elem) => {
					elem.addEventListener('change', validate.inputHandler);
				});
			} else {
				const dropdownListItemNode = dropdownsEl.querySelectorAll('.dropdown-item');
				dropdownListItemNode.forEach((elem) => {
					elem.addEventListener('click', validate.inputHandler);
				});
			}
		}

		const checkboxEls = sectionEl.querySelectorAll('input[aria-required="false"][type="checkbox"]');
		for (const checkboxEl of checkboxEls) {
			checkboxEl.required = true;
			checkboxEl.setAttribute('aria-required', 'true');

			checkboxEl.addEventListener('change', validate.inputHandler);
		}

		const radioEls = sectionEl.querySelectorAll('input[aria-required="false"][type="radio"]');
		for (const radioEl of radioEls) {
			radioEl.required = true;
			radioEl.setAttribute('aria-required', 'true');

			radioEl.addEventListener('change', validate.inputHandler);
		}
	}

	removeValidate(sectionEl) {
		const inputEls = sectionEl.querySelectorAll('input[required]:not([type="radio"]):not([type="checkbox"])');
		for (const inputEl of inputEls) {
			inputEl.removeEventListener('blur', validate.inputHandler);
			inputEl.removeEventListener('input', validate.inputHandler);
			inputEl.removeEventListener('change', validate.inputHandler);

			inputEl.required = false;
			inputEl.setAttribute('aria-required', 'false');
			this.removeErrorMsg(inputEl.closest('.form-group'));
		}

		const selectEls = sectionEl.querySelectorAll('select[required]');
		for (const selectEl of selectEls) {
			selectEl.removeEventListener('change', validate.inputHandler);

			selectEl.required = false;
			selectEl.setAttribute('aria-required', 'false');
			this.removeErrorMsg(selectEl.closest('.form-group'));
		}

		const dropdowns = sectionEl.querySelectorAll('.dropdown[required]');
		for (const dropdownsEl of dropdowns) {
			if (dropdownsEl.querySelectorAll('.checkbox').length) {
				const checkboxesNode = dropdownsEl.querySelectorAll('.checkbox');
				checkboxesNode.forEach((elem) => {
					elem.removeEventListener('change', validate.inputHandler);
				});
			} else {
				const dropdownListItemNode = dropdownsEl.querySelectorAll('.dropdown-item');
				dropdownListItemNode.forEach((elem) => {
					elem.removeEventListener('click', validate.inputHandler);
				});
			}

			dropdownsEl.removeAttribute('required');
			dropdownsEl.setAttribute('aria-required', 'false');
			this.removeErrorMsg(dropdownsEl.closest('.form-group'));
		}

		const checkboxEls = sectionEl.querySelectorAll('input[required][type="checkbox"]');
		for (const checkboxEl of checkboxEls) {
			checkboxEl.removeEventListener('change', validate.inputHandler);

			checkboxEl.required = false;
			checkboxEl.setAttribute('aria-required', 'false');
			if (checkboxEl.checked) {
				checkboxEl.checked = false;
				this.removeErrorMsg(checkboxEl.closest('.form-group'));
			}
		}

		const radioEls = sectionEl.querySelectorAll('input[required][type="radio"]');
		for (const radioEl of radioEls) {
			radioEl.removeEventListener('change', validate.inputHandler);

			radioEl.required = false;
			radioEl.setAttribute('aria-required', 'false');
			if (radioEl.checked) {
				radioEl.checked = false;
				this.removeErrorMsg(radioEl.closest('.form-group'));
			}
		}
	}

	hideSection(sectionEl) {
		if (sectionEl.getAttribute('aria-hidden') !== 'true') {
			sectionEl.hidden = true;
			sectionEl.setAttribute('aria-hidden', 'true');
		}

		this.removeValidate(sectionEl);
	}

	showSection(sectionEl) {
		if (sectionEl.getAttribute('aria-hidden') !== 'false') {
			sectionEl.removeAttribute('hidden');
			sectionEl.setAttribute('aria-hidden', 'false');
		}

		this.addValidate(sectionEl);
	}

	validateForm(containerEl) {
		const requiredFields = containerEl ? containerEl.querySelectorAll('[required]') : document.querySelectorAll(`#${this.formID} [required]`);
		let hasErrors;
		let formErrors = false;

		for (const reqField of requiredFields) {
			const error = validate.hasError(reqField);

			if (!error) {
				validate.removeError(reqField);
				// eslint-disable-next-line no-continue
				continue;
			}

			validate.showError(reqField, error);
			if (!hasErrors) hasErrors = reqField;
		}

		if (hasErrors) {
			hasErrors.focus();
			formErrors = true;
		}

		return !formErrors;
	}

	handleFormSubmit(event) {
		if (this.formID.startsWith('searchBookForm_')) event.preventDefault();

		// const iconElement = document.createElement('i');
		// iconElement.classList.add('icon', 'icon-loading-grey');
		this.oldSubmitButtonText = this.submitButton.innerText;
		this.submitButton.disabled = true;
		this.submitButton.innerText = 'Submitting';
		// this.submitButton.prepend(iconElement);

		const formValid = this.validateForm();

		if (!formValid) {
			event.preventDefault();
			this.submitButton.disabled = false;
			this.submitButton.innerHTML = this.oldSubmitButtonText;
			return false;
		}

		this.handleRecaptcha(event, (isRecaptchaCallback) => {
			if (isRecaptchaCallback) {
				this.formEl.submit();
			}

			this.onSubmit && this.onSubmit();
			this.submitData();
		});
		return true;
	}

	handleRecaptcha(event, onSubmit) {
		// skip recaptcha if the external script has not loaded - submission will be blocked back-end
		const siteKey = document.body.dataset.recaptchaSiteKey;
		const actionKey = document.body.dataset.recaptchaActionKey;
		const isReady = document.body.dataset.recaptchaIsReady === 'true';
		if (!(isReady && siteKey && actionKey)) {
			onSubmit(false);
			return;
		}

		// continue to submit if captcha has not been added to the form
		const captchaActionEl = this.formEl.querySelector(`[name="${actionKey}"]`);
		if (!captchaActionEl) {
			onSubmit(false);
			return;
		}

		// check for existing token
		const captchaTokenEl = captchaActionEl.nextElementSibling;
		if (captchaTokenEl.value) {
			onSubmit(false);
			return;
		}

		// fetch captcha token
		event.preventDefault();
		grecaptcha.execute(siteKey, { action: captchaActionEl.value }).then((token) => {
			captchaTokenEl.value = token;

			// token fetched - submit the form
			onSubmit(true);
		});
	}

	submitData() {}
}

const newsletterFormEl = document.querySelector('#newsletterForm');
if (newsletterFormEl) {
	const formID = newsletterFormEl.getAttribute('id');
	const vForm = new ValidateForm(formID);
}

// get in touch - CA=form1, AA=form9
const getInTouchFormEls = document.querySelectorAll('#form1,#form9');
if (getInTouchFormEls) {
	for (const getInTouchFormEl of getInTouchFormEls) {
		const formID = getInTouchFormEl.getAttribute('id');
		const vForm = new ValidateForm(formID);
	}
}

const formaliciousFormEls = document.querySelectorAll('.formalicious form');
if (formaliciousFormEls) {
	for (const formaliciousFormEl of formaliciousFormEls) {
		const formID = formaliciousFormEl.getAttribute('id');
		const vForm = new ValidateForm(formID);
	}
}

const searchBookFormEls = document.querySelectorAll('.search-book-form');
if (searchBookFormEls) {
	for (const searchBookFormEl of searchBookFormEls) {
		const formID = searchBookFormEl.getAttribute('id');
		const vForm = new ValidateForm(formID);

		vForm.submitData = () => {
			const linkHref = searchBookFormEl.getAttribute('data-href');
			const formData = new FormData(searchBookFormEl);
			const formIDX = formID.split('_')[1];

			const adults = formData.get(`searchBookAdults_${formIDX}`);
			const youths = formData.get(`searchBookYouth_${formIDX}`);
			const children = formData.get(`searchBookChildren_${formIDX}`);
			const infants = formData.get(`searchBookInfants_${formIDX}`);

			const whoData = {
				adults: {
					value: parseInt(adults, 10),
					label: adults,
				},
				youth: {
					value: parseInt(youths, 10),
					label: youths,
				},
				children: {
					value: parseInt(children, 10),
					label: children,
				},
				infants: {
					value: parseInt(infants, 10),
					label: infants,
				},
			};
			const formattedWho = Object.keys(whoData).reduce((acc, type) => {
				acc[type] = whoData[type]?.value ? `${whoData[type].value}:${whoData[type].label}` : '';
				return acc;
			}, {});
			const encodedWho = qs.stringify({ who: formattedWho }, { encode: true });

			if (parseInt(youths, 10) > 0) {
				const youthAlertModal = new Dialog(`#searchBookModal_${formIDX}`, 'div', 'a', false, () => {
					vForm.submitButton.disabled = false;
					vForm.submitButton.innerHTML = 'Book now';
				});

				const modalBookContinueEl = youthAlertModal.dialogNode.querySelector('.js-modal-book-continue');
				modalBookContinueEl.addEventListener('click', () => {
					window.location.href = `${linkHref}&${encodedWho}`;
				});
				return;
			}
			window.location.href = `${linkHref}&${encodedWho}`;
		};
	}
}

const taLoginFormEl = document.querySelector('#loginLoginForm');
if (taLoginFormEl) {
	const formID = taLoginFormEl.getAttribute('id');
	const vForm = new ValidateForm(formID);
}

export { ValidateForm };
